import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

import { PageIdWoofzLoveBl } from './pages'

type TIdToPageMapWoofzLoveBl = Record<PageIdWoofzLoveBl, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_LOVE_BL: TIdToPageMapWoofzLoveBl = {
  [PageIdWoofzLoveBl.DOG_SEX_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogSexQuestion').then(
        (m) => ({
          default: m.DogSexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogSexQuestion'),
  },
  [PageIdWoofzLoveBl.DOG_AGE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.DogAgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogAgeQuestion'),
  },
  [PageIdWoofzLoveBl.URGE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePage'),
  },
  [PageIdWoofzLoveBl.FEELINGS_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/FeelingsQuestion'
      ).then((m) => ({
        default: m.FeelingsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/FeelingsQuestion'),
  },
  [PageIdWoofzLoveBl.URGE_1_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePageVariant1').then(
        (m) => ({
          default: m.UrgePageVariant1,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePageVariant1'),
  },
  [PageIdWoofzLoveBl.TALKING_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/TalkingQuestion'
      ).then((m) => ({
        default: m.TalkingQustion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/TalkingQuestion'),
  },
  [PageIdWoofzLoveBl.DOG_FOLLOW_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/DogFollowQuestion'
      ).then((m) => ({
        default: m.DogFollowQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogFollowQuestion'),
  },
  [PageIdWoofzLoveBl.LICKING_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/LickingQuestion'
      ).then((m) => ({
        default: m.LickingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/LickingQuestion'),
  },
  [PageIdWoofzLoveBl.URGE_2_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzLoveBl.BEHAVIOR_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/BehaviorQuestion'
      ).then((m) => ({
        default: m.BehaviorQustion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/BehaviorQuestion'),
  },
  [PageIdWoofzLoveBl.FEEL_GUILTY_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/FeelGuiltyQuestion'
      ).then((m) => ({
        default: m.FeelGuiltyQustion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/FeelGuiltyQuestion'),
  },
  [PageIdWoofzLoveBl.URGE_3_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePageVariant3'),
  },
  [PageIdWoofzLoveBl.DOG_REACT_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/DogReactionQuestion'
      ).then((m) => ({
        default: m.DogReactionQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogReactionQuestion'),
  },
  [PageIdWoofzLoveBl.SATISFIED_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/SatisfiedQuestion'
      ).then((m) => ({
        default: m.SatisfiedQustion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/SatisfiedQuestion'),
  },
  [PageIdWoofzLoveBl.BEHAVIOR_ISSUES_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/BehaviorIssuesQuestion'
      ).then((m) => ({
        default: m.BehaviorIssuesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/BehaviorIssuesQuestion'
      ),
  },
  [PageIdWoofzLoveBl.YOUR_REACTION_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/YourReactionQuestion'
      ).then((m) => ({
        default: m.YourReactionQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/YourReactionQuestion'
      ),
  },
  [PageIdWoofzLoveBl.URGE_4_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzLoveBl.DOG_BREED_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzLoveBl.COMMANDS_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogCommands'),
  },
  [PageIdWoofzLoveBl.DOG_NAME_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/DogNameQuestion'
      ).then((m) => ({
        default: m.DogNameQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogNameQuestion'),
  },
  [PageIdWoofzLoveBl.LOVE_LOAD_SCREEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/prepareFlow/LoaderScreen').then(
        (m) => ({
          default: m.LoaderScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/prepareFlow/LoaderScreen'),
  },
  [PageIdWoofzLoveBl.DOG_PROFILE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/statistics/DogStatistics').then(
        (m) => ({
          default: m.DogStatistics,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/statistics/DogStatistics'),
  },
  [PageIdWoofzLoveBl.MOTIVATION_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/MotivationQuestion'
      ).then((m) => ({
        default: m.MotivationQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/MotivationQuestion'),
  },
  [PageIdWoofzLoveBl.FEEL_DOG_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/FeelDogQuestion'
      ).then((m) => ({
        default: m.FeelDogQustion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/FeelDogQuestion'),
  },
  [PageIdWoofzLoveBl.FREQUENCY_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/questions/FrequencyQuestion'
      ).then((m) => ({
        default: m.FrequencyQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/FrequencyQuestion'),
  },
  [PageIdWoofzLoveBl.PREPARE_FLOW_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdWoofzLoveBl.EMAIL_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_love_bl/pages/email/EmailPage'),
  },
  [PageIdWoofzLoveBl.NEWSLETTER_URGE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzLoveBl.PERSONALIZED_PLAN_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/PersonalizedPlan').then(
        (m) => ({
          default: m.PersonalizedPlan,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/urge/PersonalizedPlan'),
  },
  [PageIdWoofzLoveBl.LAST_CHANCE_OFFER_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/last-chance-offer/LastChanceOfferPage'
      ).then((m) => ({
        default: m.LastChanceOfferPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/last-chance-offer/LastChanceOfferPage'
      ),
  },
  [PageIdWoofzLoveBl.SUBSCRIPTIONS_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/subscriptions/SubscriptionsPage'
      ),
  },
  [PageIdWoofzLoveBl.LAST_CHANCE_OFFER_2_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogSexQuestion').then(
        (m) => ({
          default: m.DogSexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/questions/DogSexQuestion'),
  },
  [PageIdWoofzLoveBl.CANCEL_OFFER_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/subscriptions/CancelOfferPage'
      ).then((m) => ({
        default: m.CancelOfferPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/subscriptions/CancelOfferPage'),
  },
  [PageIdWoofzLoveBl.CHAT_UPSELL_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzLoveBl.UPSELL_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_love_bl/pages/upsell/Upsell'),
  },
  [PageIdWoofzLoveBl.UPSELL_FEEDING_GUIDE_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/upsell/FeedingGuideUpsell'
      ).then((m) => ({
        default: m.FeedingGuideUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzLoveBl.UPSELL_EMOTIONAL_SUPPORT_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love_bl/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzLoveBl.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdWoofzLoveBl.DOWNLOAD_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love_bl/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love_bl/pages/download-app/DownloadApp'),
  },
}
